import { type Offer } from "@core/offers/types";
import { trans } from "@mongez/localization";
import { TicketPercent } from "lucide-react";
import { OfferCard } from "./OfferCard";

interface OffersListProps {
  offers: Offer[];
  title?: string;
  description?: string;
}

export function OffersList({ offers, title, description }: OffersListProps) {
  if (!offers || offers.length === 0) {
    return (
      <div className="app-surface px-6 py-14 text-center">
        <span className="mx-auto mb-4 grid size-14 place-items-center rounded-2xl bg-primary/10 text-primary">
          <TicketPercent className="size-7" />
        </span>
        <p className="font-bold text-slate-500 dark:text-slate-400">
          {trans("offers.noOffersAvailable")}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {(title || description) && (
        <div className="app-surface relative overflow-hidden px-6 py-10 text-center sm:px-10 sm:py-12">
          <div className="pointer-events-none absolute -end-16 -top-20 size-52 rounded-full bg-primary/10 blur-3xl" />
          <span className="relative mx-auto mb-4 grid size-14 place-items-center rounded-2xl bg-primary text-primary-foreground shadow-lg shadow-primary/20">
            <TicketPercent className="size-7" />
          </span>
          {title && (
            <h2 className="relative text-3xl font-black tracking-tight text-slate-950 dark:text-white sm:text-4xl">
              {title}
            </h2>
          )}
          {description && (
            <p className="relative mx-auto mt-3 max-w-2xl text-base leading-7 text-slate-500 dark:text-slate-400 sm:text-lg">
              {description}
            </p>
          )}
        </div>
      )}

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {offers.map((offer) => (
          <OfferCard key={offer.id} offer={offer} />
        ))}
      </div>
    </div>
  );
}
